import { useCallback, useEffect, useState } from 'react';
import { EXPERIMENTS } from '../../constants';
import { useExperiments } from '../../contexts/experiments-context';
import { getSuggestedEmail } from './get-suggested-email';
export const useEmailMistypeCheck = ({ email, hasError })=>{
    const { isExperimentEnabled } = useExperiments();
    const checkEmailMistypeEnabled = isExperimentEnabled(EXPERIMENTS.CHECK_EMAIL_MISTYPE);
    const suggestedEmail = getSuggestedEmail((email ?? '').trim());
    const [isMistyped, setIsMistyped] = useState(false);
    const validate = useCallback(()=>{
        setIsMistyped(checkEmailMistypeEnabled && !hasError && suggestedEmail !== null);
    }, [
        checkEmailMistypeEnabled,
        hasError,
        suggestedEmail
    ]);
    useEffect(()=>{
        setIsMistyped(false);
    }, [
        email,
        hasError
    ]);
    return {
        isMistyped,
        suggestedEmail,
        validate
    };
};

//# sourceMappingURL=use-email-mistype-check.js.map